import React, {PureComponent} from 'react';
import { formatCurrency, formatSqFeet, findResaleCommunityValue, daysListed,
    imageResize, findImage, ShowValueWithIcon, trackClick } from '../util/util.js';
import { House, Bed, Bathtub, Tape } from '../util/icons_svg.js';

export default class ListingInfo extends PureComponent {
    render() {
        const {properties, hoveredPopup, clickFunction} = this.props;

        return <div className="popup-inner">
            {
            properties.map(item => {
                const enhancedBroker = (item.broker_marketing_level && item.broker_marketing_level.toUpperCase() === 'ENHANCED') ? true : false
                const enhancedAgent = (item.agent_marketing_level && item.agent_marketing_level.toUpperCase() === 'ENHANCED') ? true : false
                const isCommunity = (item.list_type && item.list_type.toUpperCase() === 'COMMUNITY') ? true : false
                const premier = item.premier_listing && item.premier_listing.toUpperCase() === 'ON';
                return (
            <div
                className={`image-container listing-popup ${(hoveredPopup === item.ad_id) ? 'listing-popup-highlight' : ''}`}
                onClick={() => {
                    // TRACK: map_to_detail_click
                    trackClick('map_to_detail_click',`map_to_detail_click: ${item.ad_id}`);
                    clickFunction(item, item.ad_id)
                }}>
                {!!findImage(item.images)
                    ? <img height="120" width="180" alt="" src={imageResize(findImage(item.images), 180)} />
                    : <div className="listing-popup-no-photo"><House />Photos Coming Soon</div>
                }
                <div className="property-alerts">
                    {premier &&
                        <div className="premier-div">Premier</div>
                    }
                    {(!!item.just_listed && item.just_listed.toUpperCase() === 'ON')
                        ? <div className="just-listed-div">Just Listed</div>
                        : (!enhancedAgent && !enhancedBroker && !premier && !isCommunity)
                            ? <div className="just-listed-div">Listed {daysListed(item.date_created)}</div>
                            : null}
                    {!!item.showcase_home
                        ? <div className="showcase-div">Showcase</div>
                        : null}
                    {!!item.foreclosure
                        ? <div className="foreclosure-div">Foreclosure</div>
                        : null}
                    {!!item.open_house
                        ? <div className="open-house-div">Open House</div>
                        : null}
                </div>
                <div className="listing-popup-text">
                    <div className="price">
                        <ShowValueWithIcon
                            list_type={item.list_type}
                            exact={item.price}
                            min={item.rent_min}
                            max={item.rent_max}
                            transform={formatCurrency}
                        />
                    </div>
                    <div className="dimensions">
                        <ShowValueWithIcon
                            list_type={item.list_type}
                            exact={item.beds}
                            min={item.bed_min}
                            max={item.bed_max}
                            field='bd'
                            icon={<Bed/>}
                        />
                        <ShowValueWithIcon
                            list_type={item.list_type}
                            exact={item.baths}
                            min={item.bath_min}
                            max={item.bath_max}
                            field='ba'
                            icon={<Bathtub/>}
                        />
                        <ShowValueWithIcon
                            list_type={item.list_type}
                            exact={item.number_sqfeet}
                            icon={<Tape/>}
                            transform={formatSqFeet}
                        />
                    </div>
                </div>
            </div>
        )})
      }
        </div>
    }
}
